import "scripts/templates/page.find-a-retailer.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.find-a-retailer");
